import React from "react";
import { Link, Outlet } from "react-router-dom";
// import { LocationFilter } from "./LocationRateFilter";
// import { useState } from "react";

function RatesnavBar(props) {
  return (
    <>
      <nav
        style={{
          marginTop: props.bottomDist,
          marginBottom: "10px",marginLeft:'5px',
          fontSize: "13px"
        }}
      >
        <Link className="px-2" to="./">
          All Rates
        </Link>
        <Link className="px-2" to="./ColumbiaRateTable">
          Columbia Rates
        </Link>
        <Link className={"px-2"} to="AllenRateTable">
          Allen Rates
        </Link>
        <Link className="px-2" to="CornellRateTable">
          Cornell Rates
        </Link>
        <Link className="px-2" to="MethodistRateTable">
          Methodist Rates
        </Link>
        <Link className="px-2" to="LowerManhattanRateTable">
          Lower Manhattan Rates
        </Link>

        <Link className="px-2" to="ParkingCost">
          Daily Rate Calculator
        </Link>
        <Link className="px-2" to="MonthlyProrateForm">
          Prorate Calculator
        </Link>
      </nav>
      <Outlet />
    </>
  );
}
export default RatesnavBar;
